import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Root from '@layouts/Root/Root';
import ErrorBoundary from '@layouts/ErrorBoundary/ErrorBoundary';
import ProtectedRoute from '@middlewares/ProtectedRoute';
import ProfilePage from '@pages/volunteers/ProfilePage/ProfilePage';
import CreateProfilePage from '@pages/volunteers/CreateProfilePage/CreateProfilePage';
import EditProfilePage from '@pages/volunteers/EditProfilePage/EditProfilePage';
import RegistrationsPage from '@pages/assessors/RegistrationsPage/RegistrationsPage';
import VolunteerDetailsPage from '@pages/assessors/VolunteerDetailsPage/VolunteerDetailsPage';
import EventsPage from '@pages/assessors/EventsPage/EventsPage';
import ErrorPage from '@pages/shared/ErrorPage/ErrorPage';

import { ROLE_ADMIN, ROLE_VOLUNTEER, ROLE_ASSESSOR } from '@services/users';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/user/profile',
        element: (
          <ProtectedRoute
            element={<ProfilePage />}
            allowedRoles={[ROLE_VOLUNTEER]}
          />
        ),
      },
      {
        path: '/user/create-profile',
        element: (
          <ProtectedRoute
            element={<CreateProfilePage />}
            allowedRoles={[ROLE_VOLUNTEER]}
          />
        ),
      },
      {
        path: '/user/edit-profile',
        element: (
          <ProtectedRoute
            element={<EditProfilePage />}
            allowedRoles={[ROLE_VOLUNTEER]}
          />
        ),
      },
      {
        path: '/user/admin',
        element: (
          <ProtectedRoute
            element={<RegistrationsPage />}
            allowedRoles={[ROLE_ADMIN, ROLE_ASSESSOR]}
          />
        ),
      },
      {
        path: '/user/admin/events',
        element: (
          <ProtectedRoute
            element={<EventsPage />}
            allowedRoles={[ROLE_ADMIN, ROLE_ASSESSOR]}
          />
        ),
      },
      {
        path: '/user/admin/users/:userId',
        element: (
          <ProtectedRoute
            element={<VolunteerDetailsPage />}
            allowedRoles={[ROLE_ADMIN, ROLE_ASSESSOR]}
          />
        ),
      },
      {
        path: '/user/error',
        element: <ErrorPage />,
      },
    ],
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
